<mx-base-form-field [fieldName]="fieldName" [overrideLabel]="overrideLabel" [externalLabel]="externalLabel" [formGroup]="formGroup" [control]="control"
                    [focused]="focused" [enabled]="enabled" [hintLabel]="hintLabel" matAutocompleteOrigin #autoCompleteOrigin="matAutocompleteOrigin">

  <input matInput mxNumericOnly type="number" inputmode="numeric" pattern="[0-9]+([,\.][0-9]+)?" [integerOnly]="integerOnly" [formControl]="control"
         [placeholder]="placeholder" [matAutocomplete]="autocompleteElement" [matAutocompleteDisabled]="!autocompleteElement"
         [matAutocompleteConnectedTo]="autoCompleteOrigin" (focus)="onFocusInput()" (blur)="onBlurInput()" (keydown.enter)="onKeydownEnter()"
         [class.text-right]="alignRight" class="input-form-field grow w-full" [autocomplete]="overrideBrowserAutocomplete ?? 'off'"/>

  @if (postfixText) {
    <span>&nbsp;{{ postfixText }}</span>
  }

  @if (showClearButton) {
    <mx-icon-button icon="clear" [customContentTemplate]="(replaceClearButtonWithSpinner | select) ? clearButtonSpinner : undefined"
                    (mousedown)="$event.preventDefault()" (click)="onClickClearButton()"/>
  }

  @if (showAuxiliaryButton) {
    <mx-icon-button [icon]="auxiliaryButtonIconName" [iconClasses]="auxiliaryButtonIconClass" (mousedown)="$event.preventDefault()"
                    (click)="onClickAuxiliaryButton()"/>
  }
</mx-base-form-field>

<ng-template #clearButtonSpinner>
  <mat-spinner [diameter]="24"/>
</ng-template>
